import { useState, useEffect } from "react";
import { 
  subscribeToPartners, 
  subscribeToPartnerCategories,
  addPartner, 
  updatePartner, 
  deletePartner,
  uploadPartnerAttachment,
  deletePartnerAttachment
} from "../services/partnersService";

export function usePartners() {
  const [partners, setPartners] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let unsubscribePartners = () => {};
    let unsubscribeCategories = () => {};

    try {
      setLoading(true);
      unsubscribePartners = subscribeToPartners((data, err) => {
        if (err) {
          setError("Failed to load partners.");
        } else {
          setPartners(data);
        }
        setLoading(false);
      });

      unsubscribeCategories = subscribeToPartnerCategories((data, err) => {
        if (err) {
          setError("Failed to load partner categories.");
        } else {
          setCategories(data);
        }
      });
    } catch (err) {
      console.error(err);
      setError("Failed to initialize partners subscriptions.");
      setLoading(false);
    }

    return () => {
      unsubscribePartners();
      unsubscribeCategories();
    };
  }, []);

  const handleAddPartner = async (data) => {
    try {
      setError("");
      return await addPartner(data);
    } catch (err) {
      console.error("Error adding partner:", err);
      setError(err.message || "Failed to add partner.");
      throw err;
    }
  };

  const handleUpdatePartner = async (id, data) => {
    try {
      setError("");
      await updatePartner(id, data);
    } catch (err) {
      console.error("Error updating partner:", err);
      setError(err.message || "Failed to update partner.");
      throw err;
    }
  };

  const handleDeletePartner = async (id) => {
    try {
      setError("");
      await deletePartner(id);
    } catch (err) {
      console.error("Error deleting partner:", err);
      setError(err.message || "Failed to delete partner.");
      throw err;
    }
  };

  return {
    partners,
    categories,
    loading,
    error,
    setError,
    addPartner: handleAddPartner,
    updatePartner: handleUpdatePartner,
    deletePartner: handleDeletePartner,
    uploadPartnerAttachment,
    deletePartnerAttachment
  };
}
